import { CheckboxProps } from '@/interfaces';
import TypoGraphy from '@/typography';
import React from 'react';
import { projectImages } from '../../../public/Assets/Images';
import './index.scss';
import eventTracker from '@/utils/eventTracker';
import Image from 'next/image';
import { gumletLoader } from '@/utils/gumlet';
const Checkbox = ({
  isActive,
  text,
  textVariant,
  setIsActive
}: CheckboxProps) => {
  const handleClick = (isActive: boolean) => {
    if (!isActive) {
      eventTracker.freeCourseFiltered({
        filterType: 'expertise',
        filteredBy: text
      });
    }
    setIsActive(!isActive);
  };
  return <div className="checkbox_wrapper" onClick={() => handleClick(isActive)} data-sentry-component="Checkbox" data-sentry-source-file="index.tsx">
    {isActive ? <Image loader={gumletLoader} width={20} height={20} src={projectImages.checkboxFilled} alt="active" loading='lazy' /> : <Image loader={gumletLoader} width={20} height={20} src={projectImages.checkboxEmpty} alt="not_active" loading='lazy' />}
    {text && textVariant && <div className="text_wrapper">
        <TypoGraphy text={text} variant={textVariant} />
    </div>}
    </div>;
};
export default Checkbox;